module.exports = __webpack_public_path__ + "assets/health_white.94e7af98.svg";